import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { Node, Text } from 'slate';
export var Utils = {
  pathNormalize: function pathNormalize(originalPath) {
    var oldPath = originalPath.split('/');
    var newPath = [];
    for (var i = 0; i < oldPath.length; i++) {
      if (oldPath[i] === '.' || oldPath[i] === '') {
        continue;
      } else if (oldPath[i] === '..') {
        newPath.pop();
      } else {
        newPath.push(oldPath[i]);
      }
    }
    return newPath.join('/');
  }
};
export var isEmptyParagraph = function isEmptyParagraph(node) {
  if (node.type !== 'paragraph') return false;
  if (node.children.length === 1 && Text.isText(node.children[0]) && Node.text(node).length === 0) {
    return true;
  }
  return false;
};

// root -> paragraph -> 
export var replaceColumnData = function replaceColumnData(mdNodes, columns, getCellValue, updateImgUrl) {
  for (var i = 0; i < mdNodes.length; i++) {
    var node = mdNodes[i];
    if (node.type === 'column') {
      var _ret = function () {
        var data = node.data;
        var column = columns.find(function (column) {
          return column.key === data.key;
        });
        var value = column ? getCellValue && getCellValue(column) : '';
        // change column node to text node
        var newNode = {
          'text': value,
          "BOLD": data.bold,
          "ITALIC": data.italic
        };
        mdNodes.splice(i, 1, newNode);
        return "continue";
      }();
      if (_ret === "continue") continue;
    }
    // replace image node's src
    if (node.type === 'image') {
      var data = node.data || {
        src: ''
      };
      if (updateImgUrl && typeof updateImgUrl === 'function') {
        var src = updateImgUrl(data.src);
        var newData = _objectSpread(_objectSpread({}, data), {
          src: src
        });
        node.data = newData;
      }
    }
    // if node has children, traverse node's children
    if (node.children) {
      var nodes = node.children;
      replaceColumnData(nodes, columns, getCellValue, updateImgUrl);
    }
  }
};